import { formatDob } from '../utils/dobFormatter'

export default function(store, { host }) {
  const Patient = store.defineModel('patient', {
    replaceKeys: {
      patientMrn: 'mrn',
      patientGender: 'gender',
      patientDob: 'dob',
    },

    parseAttrs(attrs) {
      if ('featureService' in attrs) delete attrs['featureService']

      if ('patientContacts' in attrs) delete attrs['patientContacts']

      if ('isPatientContact' in attrs) delete attrs['isPatientContact']

      if ('dob' in attrs) {
        attrs.dob = formatDob(attrs.dob)
      }

      return attrs
    },

    relations: {
      belongsTo: {
        user: { type: 'user', foreignKey: 'userId' },
      },
      hasMany: {
        contacts: { type: 'patientContact', foreignKey: 'patientId' },
      },
    },
  })

  return Patient
}
